import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { OktaCallbackComponent } from "@okta/okta-angular";
import { HomeComponent } from "./deployment/components/home/home.component";
import { DocumentComponent } from "./pages/document/document.component";
import { LoginComponent } from "./pages/login/login.component";
import { LogoutComponent } from "./pages/logout/logout.component";
import { NotFoundComponent } from "./pages/not-found/not-found.component";
import { SamlLoginComponent } from "./pages/saml-login/saml-login.component";
import { ImagesListComponent } from "./images/images-list/images-list.component";
import { RouteGuard } from "../core/route-guards/route-guard.guard";


export function getRoutes(): Routes {
  const authType = JSON.parse(localStorage.getItem('authenticationType') || '0');
  const commonRoutes: Routes = [
    {
      path: 'Images', component: ImagesListComponent, canActivate: [RouteGuard],
    },
    { path: "Home", redirectTo: "Home", pathMatch: "full" },
    { path: "Dashboard", redirectTo: "Dashboard", pathMatch: "full" },
    {
      path: "AI Studio",
      loadChildren: () => import("./ai-studio/ai-studio.module").then((m) => m.AiStudioModule),
    },
    { path: "Reports", redirectTo: "Reports", pathMatch: "full" },
    { path: "Deployment List", redirectTo: "Deployments List", pathMatch: "full" },
    { path: "Storage List", redirectTo: "Storages List", pathMatch: "full" },
    { path: "Job List", redirectTo: "Jobs List", pathMatch: "full" },
    {
      path: "MLOps List",
      loadChildren: () => import("./ml/ml.module").then((m) => m.MlModule),
    },
    { path: "User List", redirectTo: "Users List", pathMatch: "full" },
    { path: "Node List", redirectTo: "Nodes List", pathMatch: "full" },
    { path: "Application List", redirectTo: "Applications List", pathMatch: "full" },
    { path: "Licenses List", redirectTo: "License Servers List", pathMatch: "full" },
    { path: "Repo", redirectTo: "Repo", pathMatch: "full" },
    { path: "Sessions List", redirectTo: "Session List", pathMatch: "full" },
    { path: "Client Session", redirectTo: "Client Sessions", pathMatch: "full" },
    { path: "Login", component: LoginComponent },
    { path: "Client/Login", component: LoginComponent },
    { path: "Client/desktopapp/Login", component: LoginComponent },
    { path: "Client/webapp/Login", component: LoginComponent },
    { path: "Logout", component: LogoutComponent },
    { path: "Documentation", component: DocumentComponent },
    { path: "login/callback", component: OktaCallbackComponent },
    { path: "Saml", component: SamlLoginComponent },
    { path: "Conf", redirectTo: "Configurator", pathMatch: "full" },
    { path: "NotFound", component: NotFoundComponent },
    { path: "**", redirectTo: "/NotFound" },
  ];

  const pingRoutes: Routes = [
    { path: 'Images', component: ImagesListComponent },
    { path: "Home", redirectTo: "Home", pathMatch: "full" },
    { path: "Dashboard", redirectTo: "Dashboard", pathMatch: "full" },
    {
      path: "AI Studio",
      loadChildren: () => import("./ai-studio/ai-studio.module").then((m) => m.AiStudioModule),
    },
    { path: "Reports", redirectTo: "Reports", pathMatch: "full" },
    { path: "Deployment List", redirectTo: "Deployments List", pathMatch: "full" },
    { path: "Storage List", redirectTo: "Storages List", pathMatch: "full" },
    { path: "Job List", redirectTo: "Jobs List", pathMatch: "full" },
    {
      path: "MLOps List",
      loadChildren: () => import("./ml/ml.module").then((m) => m.MlModule),
    },
    { path: "User List", redirectTo: "Users List", pathMatch: "full" },
    { path: "Node List", redirectTo: "Nodes List", pathMatch: "full" },
    { path: "Application List", redirectTo: "Applications List", pathMatch: "full" },
    { path: "Licenses List", redirectTo: "License Servers List", pathMatch: "full" },
    { path: "Repo", redirectTo: "Repo", pathMatch: "full" },
    { path: "Sessions List", redirectTo: "Session List", pathMatch: "full" },
    { path: "Client Session", redirectTo: "Client Sessions", pathMatch: "full" },
    { path: "Login", component: HomeComponent },
    { path: "Client/Login", component: HomeComponent },
    { path: "Client/desktopapp/Login", component: HomeComponent },
    { path: "Client/webapp/Login", component: HomeComponent },
    { path: "Logout", component: LogoutComponent },
    { path: "Documentation", component: DocumentComponent },
    { path: "login/callback", component: OktaCallbackComponent },
    { path: "Saml", component: SamlLoginComponent },
    { path: "Conf", redirectTo: "Configurator", pathMatch: "full" },
    { path: "NotFound", component: NotFoundComponent },
    { path: "**", redirectTo: "/NotFound" },
  ];

  // Include login routes only if NOT Ping
  if (authType === 6 || authType === 2) {
    return pingRoutes;
  } else {
    return commonRoutes;
  }
}

@NgModule({
  imports: [
    RouterModule.forRoot(getRoutes(), { scrollPositionRestoration: "enabled" }),
  ],
  exports: [RouterModule],
})
export class ComponentsRoutingModule { }
